export const POI = 'poi'
export const ADDRESS = 'address'
